import type { ComputedRef } from 'vue';
import { readonly, computed, shallowRef } from 'vue';
import type { AppConfigType } from '@/shared/api/app-config';

// TODO: better types for initial and complete state
function makeAppConfig() {
  // lang / locale лучше брать синхронно
  // из-за большого количества синхронных вызовов trlMessage и подобного.
  // TODO: фолбэк на en-US для фронтовых тестов. Сходу замокать не получилось
  const docLocale = document.documentElement.getAttribute('lang') || 'en-US';
  const locale = docLocale.replace('-', '_');
  const lang = docLocale.split('-')[0] as AppConfigType['lang'];
  const isMobile = checkHasTouchScreen();

  const config = shallowRef<AppConfigType>({
    ...{
      locale: locale as AppConfigType['locale'],
      lang
    },
    ...window.AppInitConfig,
    is_mobile: isMobile
  });
  const setConfig = (data: AppConfigType) => {
    config.value = {
      ...data,
      is_mobile: config.value.is_mobile ?? isMobile,
      locale: data.locale ?? config.value.locale,
      lang: data.lang ?? config.value.lang,
      timeDiff: Number.parseInt(String(new Date().getTime() / 1000)) - data.currentTime
    };
  };
  const readonlyConfig = readonly(config);

  /**
   * @deprecated
   */
  const get = <K extends keyof AppConfigType>(key: K): AppConfigType[K] => {
    return (readonlyConfig.value as AppConfigType)[key];
  };

  const cloudRegionHost = computed(() => `https://huntflow.${get('instanceRegion').toLowerCase()}`);
  const isAuthorized = computed(() => Boolean(get('account')));
  const isAutoPhoneformatEnabled = computed(() => Boolean(get('phoneCountryCode')));
  const isBlogAvailable = computed(() => get('instanceRegion') !== 'AI');
  return {
    config: readonlyConfig as ComputedRef<AppConfigType>,
    setConfig,
    get,
    cloudRegionHost,
    isAuthorized,
    isAutoPhoneformatEnabled,
    isBlogAvailable
  };
}

export const appConfig = makeAppConfig();

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_device_detection
function checkHasTouchScreen() {
  if (navigator.maxTouchPoints > 0) {
    return true;
  }
  const mq = matchMedia('(pointer:coarse)');
  if (mq.media === '(pointer:coarse)' && mq.matches) {
    return true;
  }
  if ('orientation' in window) {
    return true;
  }
  const UA = navigator.userAgent;
  return (
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA)
    || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
  );
}
